// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-guide {\n  text-align: center;\n}\n.box-guide div > figure {\n  width: 200px;\n  margin: 0 auto;\n}\n.box-guide div > figure > img {\n  width: 100%;\n  height: auto;\n}\n.box-guide p > figure,\n.box-guide p > img {\n  display: inline-block;\n  vertical-align: middle;\n  width: 72px;\n}\n", ""]);
// Exports
module.exports = exports;
